import { components, GroupBase, OptionProps } from 'react-select';

import './option.component.scss';

function Option<Option, IsMulti extends boolean, Group extends GroupBase<Option>>({
  children,
  ...props
}: OptionProps<Option, IsMulti, Group>) {
  const { onMouseMove, onMouseOver, ...innerProps } = props.innerProps;
  const newProps = { ...props, innerProps };

  return (
    <components.Option
      className="select-option"
      {...newProps}>
      {children}
    </components.Option>
  );
}

export default Option;
